import React from "react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {TippingHistoryRecordDateContainerBox} from "./boxes/middle-section/date/tipping-history-record-date-container.box";
import {TippingHistoryRecordCalendarBox} from "./boxes/middle-section/date/calendar/tipping-history-record-calendar.box";
import {HistoryRecordDateValueBox} from "./boxes/middle-section/date/value/history-record-date-value.box";
import {CyClass} from "../../../../../common/cy-classes";
import {TippingHistoryRecordMiddleSectionBox} from "./boxes/middle-section/tipping-history-record-middle-section.box";
import {observer} from "mobx-react";
import {ITippingHistoryRecordViewModel} from "../../../../services/tipping-history/models/tipping-history-view-model.interface";

interface TippingHistoryRecordMiddleSectionComponentProps {
    record: ITippingHistoryRecordViewModel;
}

export const TippingHistoryRecordContentMiddleSectionComponent = observer(
    class TippingHistoryRecordContentMiddleSectionComponent extends OrbitComponent<TippingHistoryRecordMiddleSectionComponentProps> {
        
        render() {
            return (
                <TippingHistoryRecordMiddleSectionBox>
                    <TippingHistoryRecordDateContainerBox>
                        <TippingHistoryRecordCalendarBox/>
                        <HistoryRecordDateValueBox className={CyClass('cy-tipping-history-play-date')}>
                            {this.services.regulation.current.timeFormatter.formatHistoryRecordDate(this.props.record.tipDate)}
                        </HistoryRecordDateValueBox>
                    </TippingHistoryRecordDateContainerBox>
                </TippingHistoryRecordMiddleSectionBox>
            );
        }
    }
);